<template>
  <div class="page page_prices">
    <PricesTable />
    <PricesCarousel />
    <PricesAccessories />
    <PricesOutro />
    
  </div>
</template>

<script>
import PricesTable from '@/components/prices/PricesTable.vue'
import PricesAccessories from '@/components/prices/PricesAccessories.vue'
import PricesOutro from '@/components/prices/PricesOutro.vue'
import PricesCarousel from '@/components/prices/PricesCarousel.vue'

export default {
  name: 'Prices',
  components: { PricesTable, PricesAccessories, PricesOutro, PricesCarousel }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.page {
  padding: 0;
  max-width: none;
  margin: 0;

  &_prices {
    min-height: auto;
  }
}
</style>
